import { render, staticRenderFns } from "./my-alpitour.vue?vue&type=template&id=11b746c2&"
import script from "./my-alpitour.vue?vue&type=script&lang=js&"
export * from "./my-alpitour.vue?vue&type=script&lang=js&"
import style0 from "./my-alpitour.vue?vue&type=style&index=0&id=11b746c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports